import { render, staticRenderFns } from "./folder-add-outline.vue?vue&type=template&id=3b26ace7&"
import script from "./folder-add-outline.vue?vue&type=script&lang=js&"
export * from "./folder-add-outline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b26ace7')) {
      api.createRecord('3b26ace7', component.options)
    } else {
      api.reload('3b26ace7', component.options)
    }
    module.hot.accept("./folder-add-outline.vue?vue&type=template&id=3b26ace7&", function () {
      api.rerender('3b26ace7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/folder-add-outline.vue"
export default component.exports